function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_87",
  "data-name": "Path 87",
  d: "M0,0H16V16H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_316",
  "data-name": "Group 316",
  transform: "translate(-1477.024 -776.671)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_158",
  "data-name": "Path 158",
  d: "M1490.561,778.917h-11.072a.127.127,0,0,0-.127.127v.761a.127.127,0,0,0,.127.127h1.452a.125.125,0,0,1,.126.126V781.9a.384.384,0,0,0,.094.25l.918,1.053a.38.38,0,0,1,.093.249v2.013a.127.127,0,0,0,.127.127h5.451a.127.127,0,0,0,.127-.127v-2.013a.381.381,0,0,1,.093-.249l.918-1.053a.384.384,0,0,0,.094-.25v-1.837a.125.125,0,0,1,.126-.126h1.453a.126.126,0,0,0,.126-.127v-.761A.126.126,0,0,0,1490.561,778.917Z",
  fill: "#4d4d4d"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1366",
  "data-name": "Rectangle 1366",
  width: 7.914,
  height: 1.014,
  rx: 0.127,
  transform: "translate(1481.068 789.643)",
  fill: "#4d4d4d"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1367",
  "data-name": "Rectangle 1367",
  width: 5.705,
  height: 2.028,
  rx: 0.127,
  transform: "translate(1482.172 786.601)",
  fill: "#4d4d4d"
}));

function SvgReducerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "more_vert-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReducerIcon);
export default __webpack_public_path__ + "static/media/reducerIcon.f93734b8.svg";
export { ForwardRef as ReactComponent };